const type = 'advanced'
const path = '/advance/html-java/'
const name = 'index.java'

const conditions = [
  {
    option: 'frontend',
    value: 'html',
  },
]

export { type, path, name, conditions }
